import { motion, useAnimation } from 'framer-motion'
import NumberAnimate from '../../NumberAnimate'
import SVGJSContainer from '../../../utils/SVGJSContainer'

function Immeubles3() {
	const controls = useAnimation()
	return (
		<SVGJSContainer controls={controls}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="729"
				height="729"
				viewBox="0 0 729 729"
			>
				<defs>
					<linearGradient
						id="linear-gradientImmeubles3"
						x1="0.5"
						x2="0.5"
						y2="1"
						gradientUnits="objectBoundingBox"
					>
						<stop offset="0" stopColor="#00758d"></stop>
						<stop offset="1" stopColor="#84bfc2"></stop>
					</linearGradient>
				</defs>
				<g data-name="Groupe 2552" transform="translate(-173.785 -2304)">
					<path
						fill="#a9d5d8"
						d="M0 0H729V729H0z"
						data-name="Rectangle 2272"
						opacity="0.7"
						transform="translate(173.785 2285)"
					></path>
					<path
						fill="url(#linear-gradientImmeubles3)"
						stroke="rgba(0,0,0,0)"
						strokeWidth="1"
						d="M0 319.463V33.758C0 15.191 15.529 0 34.508 0h0c18.979 0 34.507 15.191 34.507 33.758v286.683z"
						data-name="Tracé 30443"
						transform="rotate(-90 1447.983 1117.208)"
					></path>
					<text
						data-name="Par financement"
						fontFamily="AcuminPro-Bold, Acumin Pro"
						fontSize="55"
						fontWeight="700"
						transform="translate(210.349 2387.153)"
					>
						<tspan x="0" y="0">
							Par financement
						</tspan>
					</text>
					<text
						data-name="Essential coats what"
						fontFamily="AcuminPro-Regular, Acumin Pro"
						fontSize="25"
						letterSpacing="-.01em"
						transform="translate(672.5 2903.917)"
					>
						<tspan x="0" y="0">
							de PLAI
						</tspan>
						<tspan fontFamily="AcuminPro-Bold, Acumin Pro" fontWeight="700">
							<tspan x="0" y="28">
								et très sociaux
							</tspan>
						</tspan>
					</text>
					<text
						data-name="5,2 %"
						fontFamily="AcuminPro-Bold, Acumin Pro"
						fontSize="30"
						fontWeight="700"
						letterSpacing="-.02em"
						transform="translate(516.14 2923.917)"
					>
						<tspan x="0" y="0">
							<NumberAnimate
								tspan
								suffix=" %"
								nb={11}
								duration={1.5}
								delay={0.5}
							/>
						</tspan>
					</text>
					<motion.path
						fill="url(#linear-gradientImmeubles3)"
						stroke="rgba(0,0,0,0)"
						strokeWidth="1"
						d="M0 178.435V30.683C0 13.808 15.529 0 34.508 0h0c18.979 0 34.507 13.808 34.507 30.683v147.752z"
						data-name="Tracé 30445"
						transform="rotate(-90 1614.894 1142.543)"
					></motion.path>

					<path
						fill="url(#linear-gradientImmeubles3)"
						stroke="rgba(0,0,0,0)"
						strokeWidth="1"
						d="M0 49.146v-13.51C0 16.037 15.528 0 34.507 0h0c18.979 0 34.508 16.037 34.508 35.636v13.51z"
						data-name="Tracé 30454"
						transform="rotate(-90 1772.782 1171.142)"
					></path>

					<path
						fill="none"
						stroke="#000"
						strokeWidth="2"
						d="M0 0L0 531"
						data-name="Ligne 687"
						transform="translate(659.5 2465.5)"
					></path>

					<text
						data-name="Essential coats what"
						fontFamily="AcuminPro-Regular, Acumin Pro"
						fontSize="25"
						letterSpacing="-.01em"
						transform="translate(672.5 2700.917)"
					>
						<tspan x="0" y="0">
							de logement
						</tspan>
						<tspan fontFamily="AcuminPro-Bold, Acumin Pro" fontWeight="700">
							<tspan x="0" y="28">
								social{' '}
							</tspan>
							<tspan x="0" y="56">
								intermédiaire
							</tspan>
						</tspan>
						<tspan x="0" y="82">
							de type PLS
						</tspan>
					</text>

					<text
						data-name="15 %"
						fontFamily="AcuminPro-Bold, Acumin Pro"
						fontSize="38"
						fontWeight="700"
						letterSpacing="-.02em"
						transform="translate(352.652 2734.917)"
					>
						<tspan x="0" y="0">
							<NumberAnimate
								tspan
								suffix=" %"
								nb={23}
								duration={1.5}
								delay={0.5}
							/>
						</tspan>
					</text>

					<text
						data-name="Essential coats what"
						fontFamily="AcuminPro-Bold, Acumin Pro"
						fontWeight="700"
						fontSize="25"
						letterSpacing="-.01em"
						transform="translate(672.5 2522.917)"
					>
						<tspan x="0" y="0">
							de PLUS
						</tspan>
						<tspan>
							<tspan x="0" y="28">
								et PLA
							</tspan>
						</tspan>
					</text>
					<text
						data-name="40,6 %"
						fontFamily="AcuminPro-Bold, Acumin Pro"
						fontSize="42"
						fontWeight="700"
						letterSpacing="-.02em"
						transform="translate(192.652 2542.917)"
					>
						<tspan x="0" y="0">
							<NumberAnimate
								tspan
								suffix=" %"
								nb={66}
								duration={1.5}
								delay={0.8}
							/>
						</tspan>
					</text>
				</g>
			</svg>
		</SVGJSContainer>
	)
}

export default Immeubles3
